import React, { FC, useState } from 'react';
import { useQuery } from 'react-query';
import {
	Box,
	Container,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
} from '@mui/material';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { useTranslation } from 'react-i18next';
import { getOrders } from '../../api/apiRequests/orders';
import UserProfileOrdersRow from './UserProfileOrdersRow';
import './UserProfileOrders.scss';
import {
	IPagination,
	TPaginationSettings,
} from '../../lib/interfaces/Pagination';
import { IOrder } from '../../lib/interfaces/Order';

const UserProfileOrders: FC = () => {
	const { t } = useTranslation();
	const [pagination, setPagination] = useState<TPaginationSettings | null>(null);
	const paginationKey = pagination
		? `${pagination.page}-${pagination.limit}`
		: '';

	const { data: ordersData } = useQuery<IPagination<IOrder>, Error>(
		['orders', paginationKey],
		() => getOrders(pagination),
	);

	const pageChange = (paginationSettings: TPaginationSettings) => {
		setPagination(paginationSettings);
	};

	const handleChangePage = (
		event: React.MouseEvent<HTMLButtonElement> | null,
		page: number,
	) => {
		if (ordersData) {
			pageChange({
				page: page + 1,
				limit: ordersData?.meta.itemsPerPage,
			});
		}
	};
	console.log('ordersData: ', ordersData);
	return ordersData && ordersData.items?.length ? (
		<div className="UserProfileOrders">
			<TableContainer component={Box}>
				<Table aria-label="collapsible table">
					<TableHead>
						<TableRow>
							<TableCell align="left">
								<strong>{t('date')}</strong>
							</TableCell>
							<TableCell>
								<strong>{t('productName')}</strong>
							</TableCell>
							<TableCell align="left">
								<strong>{t('price')}</strong>
							</TableCell>
							<TableCell align="left">
								<strong>{t('orderNumber')}</strong>
							</TableCell>
							<TableCell align="left">
								<strong>{t('orderStatus')}</strong>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{ordersData?.items.map((order: IOrder) => (
							<UserProfileOrdersRow key={order.id} order={order} />
						))}
					</TableBody>
				</Table>
			</TableContainer>
			{ordersData && (
				<TablePagination
					rowsPerPageOptions={[30]}
					component="div"
					count={ordersData.meta.totalItems}
					rowsPerPage={ordersData.meta.itemsPerPage}
					page={ordersData.meta.currentPage - 1}
					onPageChange={handleChangePage}
				/>
			)}
		</div>
	) : (
		<div>
			<Container
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					gap: '10px',
				}}
			>
				<ShoppingBasketIcon />
				<Typography variant="h5">You have no orders yet...</Typography>
			</Container>
		</div>
	);
};

export default UserProfileOrders;
